import { Button } from "antd";
import { useTranslation } from "react-i18next";

export default function PaymentButton({
  className = "",
  disabled,
  loading,
  title,
  ...props
}) {
  const { t } = useTranslation();
  return (
    <Button
      disabled={disabled}
      loading={loading}
      className={`${
        disabled ? "disabled-button-large" : "primary-button-large"
      } justify-center items-center ${className}`}
      block
      htmlType="submit"
      {...props}
    >
      {t(title)}
    </Button>
  );
}
